// src/services/appVersionService.js
import api, { fetchCsrfToken } from './api';
import { currentUrl } from '../constants/global';

const ROOT = { baseURL: currentUrl };

export const appVersionService = {
  ensureCsrf: async () => fetchCsrfToken(),

  listVersions: async () => {
    const response = await api.get('/admin/app-versions', ROOT);
    return response.data;
  },

  /**
   * Cria versão. Se `files` tiver binary_file e/ou manual_pdf_file, envia
   * multipart/form-data; senão, envia JSON puro (ex: OTA sem manual).
   * payload: campos de texto (platform, version, ...).
   * files: { binary_file?: File, manual_pdf_file?: File }
   * onProgress: callback(percent) chamado durante o upload do arquivo.
   */
  createVersion: async (payload, files = {}, onProgress) => {
    try {
      await appVersionService.ensureCsrf();

      const hasFile = Boolean(files.binary_file || files.manual_pdf_file);

      if (hasFile) {
        const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== "") {
            formData.append(key, value);
          }
        });
        if (files.binary_file) formData.append("binary_file", files.binary_file);
        if (files.manual_pdf_file) formData.append("manual_pdf_file", files.manual_pdf_file);

        // não define Content-Type manualmente — o axios/browser define
        // multipart/form-data com o boundary correto sozinho.
        const response = await api.post('/admin/app-versions', formData, {
          ...ROOT,
          onUploadProgress: (event) => {
            if (onProgress && event.total) {
              onProgress(Math.round((event.loaded * 100) / event.total));
            }
          },
        });
        return response.data;
      }

      const response = await api.post('/admin/app-versions', payload, ROOT);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao criar versão:', error.response?.data);
      throw error;
    }
  },

  updateVersion: async (guid, patch) => {
    try {
      await appVersionService.ensureCsrf();
      const response = await api.patch(`/admin/app-versions/${guid}`, patch, ROOT);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao editar versão:', error.response?.data);
      throw error;
    }
  },
};